import { render, staticRenderFns } from "./latestClueTable.vue?vue&type=template&id=9f196d7c"
import script from "./latestClueTable.vue?vue&type=script&lang=ts"
export * from "./latestClueTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports